export {default} from "./ResultAnnotation";
